<template>
  
    <div class="myCenter bg-blue-100 border-2 border-blue-800 p-1 rounded">
  
      <div class="w-full flex flex-col lg:flex-row items-start justify-around h-full pb-3 text-sm lg:text-lg text-grey-dark pt-2 lg:mr-24">
  
          <div class="flex items-center mt-2 ">
  
              <div class="myOverlayText myFullCenter">            
                  <span class="font-bold mr-1 lg:mr-4">{{$t('slot.start')}}</span>
  
                  <h2 class=" text-red-700">
                  <!-- {{this.mySlot.start_time.substring(0, this.mySlot.start_time.lastIndexOf(':'))}} -->
                  {{startTime}}
                  </h2>
              </div>
  
              <div class="myOverlayText myFullCenter">
  
                  
                  <span class="font-bold mr-1 lg:mr-4">{{$t('sessions.duration')}} </span>
  
                  <h2 class="text-pink-800">
                      {{getDuration()}}
                      </h2>
              </div>    
          
              <div class="myOverlayText myFullCenter">
                  
                  <span class="font-bold mr-1 lg:mr-4">
                          {{$t('slot.end')}}
                                  
                      </span>
                      
                  <!-- <h2 class="text-pink-700">{{this.mySlot.start_time.substring(0, this.mySlot.end_time.lastIndexOf(':'))}}</h2> -->
  
                  <!-- <h2 class="text-pink-700">{{ startTime  | moment("hh:mm A")}}</h2> -->
  
                  <h2 class="text-pink-700">{{endTime}}</h2>
              </div>
  
          </div> 
  
  
            <div class="flex lg:flex-col flex-row mt-2">
  
              <div class="flex flex-row pb-1 lg:pb-3 text-grey-dark">
                  
                  <div class="myOverlayText myFullCenter">
                      
                      <span class="font-bold">{{$t('sessions.available')}} </span>
  
                      <h2 class="text-pink-700">{{available}}</h2>
                  </div>
  
                  <div  v-if="mySlot.pay_cash" 
                  class="myOverlayText myFullCenter" >
                      
                      <span class="font-bold">{{$t('classes.cash')}} </span>
  
                      <h2 class="text-pink-700">{{mySlot.cash_cost}}</h2>
                  </div>
                  
                  <div v-if="mySlot.pay_points" 
                  class="myOverlayText myFullCenter">
                      
                      <span class="font-bold">{{$t('classes.points')}} </span>
  
                      <h2 class="text-pink-700">{{mySlot.points_cost}}</h2>
                  </div>
  
                  <div class="lg:border-r">
  
                  </div>
  
              </div>                                           
            </div>
     
          </div>
      </div>        
  </template>
  
  
  <script>
  
  import { RingLoader } from 'vue-spinners-css';
  
  import moment from 'moment';
  
  import myUpdates from '../../hasura/myUpdates';
  
  import componentsHelpers from '../../classes/componentHelpers';
  
  import cardImagesComponent from '../../components-v2/cards-components/CardImages.vue'
  import cardDetailsComponent from './SessionCardDetails.vue'
  
  import { createPopper } from '@popperjs/core';
  
  export default {
  
      created(){
  
          
          },
  
      mounted(){
          
          if(!this.mySlot.pay_points){
              
              this.paymentByPoints = false;
          }
      },
  
      props: {
  
          classType: '',
  
          
          disablePage: false,
  
          disableButton: false,
  
          isOnline: false,
  
  
          dayDate: '',
  
          mySlot:{
  
              type: Object
          },
  
          myClass:{
  
              type: Object
          },
  
          businessInfo:{
        
              type: Object,
          },
  
          instructors:{
  
              type: Array 
          },
  
          myReload: {
  
              type: Function
          },
  
          index: 0,
  
          changeCardView: {
  
              type: Function
          },
  
  
          displayModal: {
  
              type: Function
          },
      },
  
      components:{
  
          RingLoader,
          cardImagesComponent,
          cardDetailsComponent
      },
  
      methods:{
  
    
          toastIt(){
  
              const subOptions =  { 	 theme: "toasted-primary", position: "bottom-center", duration : 5000,
               keepOnHover: true, singleton:true };
              this.$toasted.clear();
              this.$toasted.info(this.myClass.description, subOptions);
          },
  
          showDescription(){
  
  
          },
  
          closePop(){
  
              this.popoverShow = false;
          },
  
          resetColor(){
  
          },  
  
          getDuration(){
  
              let minutes = ((new Date('1970/01/01 ' + this.mySlot.end_time  + '') - new Date('1970/01/01 ' + this.mySlot.start_time  + ' '))/ (1000*60));
  
              if(minutes > 720){
  
                  minutes = minutes - 720;
              }
              
              let retainValue = function (value) {
                  return Number.parseFloat(value).toPrecision(2);
              };
              moment.relativeTimeRounding(retainValue);
  
              const duration = moment.duration({"minutes": minutes}).humanize();
  
              return duration;
          },
  
          changeView(isMaximize, index){
  
              this.changeCardView(isMaximize, index);
          }
      },
  
    data: function(){
  
      return{
  
          loading:false,
          myDayDate: this.dayDate,
          startTime: moment(new Date(`1970/01/01 ${this.mySlot.start_time}`)).format('hh:mm A'),
          endTime: moment(new Date(`1970/01/01 ${this.mySlot.end_time}`)).format('hh:mm A'),
          isMaximize: true,
          bookingId: 0,
          instructorName: '',
          filteredSlots: [],
          weekDays: '',
          edit: false,
          initiated: false, 
          available: this.mySlot.capacity,
          popoverShow:false,
  
          points: 0,
          capacity: 0,
  
          days: [7],
          isBgGreen: false,
          paymentByPoints: true,
      }
    },
  
  }
  </script>
  
  <style>
  
  </style>
  